import { useTranslation } from 'react-i18next';

import { Select } from '@treezor/design-system';

import { FormFilters } from './FormFilters';

export interface IItemsPerPageProps {
  initialValue: number;
  values: number[];
  onChange: (value: number) => void;
}

export function ItemsPerPage({ initialValue, values, onChange }: IItemsPerPageProps) {
  const { t } = useTranslation();

  return (
    <FormFilters>
      <span className="typo-body-regular-caption w-fit">{t('Show rows per page')}</span>
      <Select
        defaultValue={initialValue}
        options={values.map((value) => ({
          label: value.toString(),
          value,
        }))}
        onChange={onChange}
        size="s"
        getOptionDisplay={(value) => <>{value.label}</>}
      />
    </FormFilters>
  );
}
